export const TradeDurations = [
  // tslint:disable-line
  { id: 1, name: 'Un día', show: true },
  { id: 2, name: '2 días', show: true },
  { id: 3, name: '3 días', show: true },
  { id: 4, name: '4 días', show: true },
  { id: 5, name: '5 días', show: true },
  { id: 6, name: '6 días', show: true },
  { id: 7, name: '7 días', show: true },
  { id: 8, name: '8 días', show: true },
  { id: 9, name: '9 días', show: true },
  { id: 10, name: '10 días', show: true },
  { id: 11, name: '11 días', show: false },
  { id: 12, name: '12 días', show: false },
  { id: 13, name: '13 días', show: false },
  { id: 14, name: '14 días', show: false },
  { id: 15, name: '15 días', show: true },
  { id: 16, name: '16 días', show: false },
  { id: 17, name: '17 días', show: false },
  { id: 18, name: '18 días', show: false },
  { id: 19, name: '19 días', show: false },
  { id: 20, name: '20 días', show: true },
];
